import React from 'react'
import { Currency } from 'api'
import { Field } from 'view/components/inputs'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { getEnumValues, CurrencyHelper } from 'model'

export interface CurrencySelectboxProps extends Omit<SelectboxProps<Currency, Currency>, 'optionKeys'> {
  permittedCurrencies?: Currency[]
}

export const CurrencySelectbox = React.forwardRef(({ permittedCurrencies, ...rest }: CurrencySelectboxProps, ref: React.Ref<Selectbox>) => {
  const optionKeys = getEnumValues(Currency)
    .filter(optionKey => !permittedCurrencies || permittedCurrencies.includes(optionKey))
    .sort()
  return <Selectbox ref={ref} optionKeys={optionKeys} getOptionText={CurrencyHelper.getName} {...rest} />
})

export const CurrencySelectboxField = Field(CurrencySelectbox)
